import { createColumnHelper } from "@tanstack/react-table";
import { IconButton, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useParams } from "react-router-dom";
import { useESRApprovalContext } from "../../Context/ESRApprovalContext";
import { ESRManpowerColumns } from "../ESR-Manpower/utils/types";

export const useCreateESRManpowerColumns = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const {
    setCurrentManhourSelected,
    setOpenManhourDialog,
    setMhActionType,
    setOpenMhDeleteDialog,
  } = useESRApprovalContext();

  const columnHelper = createColumnHelper<ESRManpowerColumns>();

  const esrManpowerColumns = [
    columnHelper.accessor("id", {
      header: "",
      cell: () => null,
      meta: {
        hidden: true,
      },
    }),
    columnHelper.accessor("mechanicName", {
      id: "mechanicName",
      header: "Manpower",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
    }),
    columnHelper.accessor("manHours", {
      id: "manHours",
      header: "Man Hours",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(pathSegments[2] == "create" ||
    pathSegments[2] == "edit" ||
    pathSegments[2] == "start" ||
    pathSegments[2] == "complete"
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <Stack direction="row" gap="2">
                <IconButton
                  color="primary"
                  onClick={() => {
                    const tempId = String(row.index);
                    setCurrentManhourSelected({
                      id: row.original.id ? row.original.id : tempId,
                      manHours: row.original.manHours,
                      mechanicId: row.original.mechanicId,
                      mechanicName: row.original.mechanicName,
                    });
                    setOpenManhourDialog(true);
                    setMhActionType("update");
                  }}
                >
                  <EditIcon fontSize="medium" />
                </IconButton>

                <IconButton
                  color="primary"
                  onClick={() => {
                    const tempId = String(row.index);
                    setCurrentManhourSelected({
                      id: tempId,
                      manHours: row.original.manHours,
                      mechanicId: row.original.mechanicId,
                      mechanicName: row.original.mechanicName,
                    });
                    setOpenMhDeleteDialog(true);
                  }}
                >
                  <DeleteIcon fontSize="medium" />
                </IconButton>
              </Stack>
            ),
            enableHiding: false,
          }),
        ]
      : []),
  ];

  return esrManpowerColumns;
};
